import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Progress } from "@/components/ui/progress";
import { Link } from "react-router-dom";
import { BookOpen, CheckCircle2, Calendar as CalIcon, MessageSquare } from "lucide-react";

export default function LearnerHome() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/learner/summary").then(({ data }) => setS(data)); }, []);
  if (!s) return <div className="text-[#5C6561]">Chargement…</div>;
  const pct = Math.round((s.sessions_completed / s.sessions_total) * 100);
  const next = s.next_events[0];

  return (
    <div className="lg:ml-56">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-[#D95D39] font-semibold">Bonjour {s.first_name}</div>
        <h1 className="font-serif-accent text-3xl sm:text-4xl mt-1">Prêt·e pour la suite ?</h1>
        <p className="text-[#5C6561] mt-1 text-sm">{s.program} • Niveau {s.level}</p>
      </div>

      <div className="dec-card p-6">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-wider text-[#5C6561]">Progression</div>
            <div className="text-3xl font-bold mt-1">{s.sessions_completed}<span className="text-[#5C6561] text-lg">/{s.sessions_total}</span></div>
          </div>
          <div className="text-4xl font-serif-accent text-[#D95D39]">{pct}%</div>
        </div>
        <Progress value={pct} className="mt-4" />
      </div>

      <div className="grid grid-cols-2 gap-3 mt-4">
        <Link to="/learner/seances" className="dec-card p-4 hover:border-[#D95D39]" data-testid="home-shortcut-sessions">
          <BookOpen className="w-5 h-5 text-[#D95D39]" />
          <div className="font-semibold mt-2">Mes séances</div>
          <div className="text-xs text-[#5C6561]">{s.sessions_in_progress} en cours</div>
        </Link>
        <Link to="/learner/missions" className="dec-card p-4 hover:border-[#D95D39]" data-testid="home-shortcut-missions">
          <CheckCircle2 className="w-5 h-5 text-[#2A5B52]" />
          <div className="font-semibold mt-2">Mes missions</div>
          <div className="text-xs text-[#5C6561]">{s.missions_completed}/{s.missions_total} faites</div>
        </Link>
      </div>

      {next && (
        <div className="dec-card p-5 dec-side-accent mt-4">
          <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-[#5C6561]">
            <CalIcon className="w-3.5 h-3.5" /> Prochain cours
          </div>
          <div className="mt-1 font-semibold text-lg">{next.title}</div>
          <div className="text-sm text-[#5C6561] mt-0.5">{next.date} • {next.start_time} → {next.end_time}</div>
        </div>
      )}

      {s.latest_comments.length > 0 && (
        <div className="dec-card p-5 mt-4">
          <div className="flex items-center gap-2 mb-3">
            <MessageSquare className="w-4 h-4 text-[#E5983B]" />
            <h3 className="font-serif-accent text-lg">Derniers mots de la coach</h3>
          </div>
          <div className="space-y-3">
            {s.latest_comments.map(c => (
              <div key={c.id} className="text-sm text-[#1F2421] italic border-l-2 border-[#E5983B] pl-3">
                « {c.text} »
                <div className="text-[11px] text-[#5C6561] not-italic mt-1">{new Date(c.created_at).toLocaleDateString("fr-FR")}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
